import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import "./assets/scss/mdb-pro.scss";
import { Provider } from 'react-redux';
import store from './redux/store';
import '@fortawesome/fontawesome-free/css/all.min.css'; 
import 'bootstrap-css-only/css/bootstrap.min.css'; 
import 'mdbreact/dist/css/mdb.css';
import { Application } from 'react-rainbow-components';
import { theme } from './components/shared/React-Rainbow-Theme';

ReactDOM.render(
  /* strict mode has to be removed otherwise the sort function on MDBDatables does not work properly */
  // <React.StrictMode>
    <Provider store={store}>
    <Application theme={theme}>
      <App />
      </Application>
    </Provider>,
  //  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
